import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/forms.css'; // Optional, for styling

export default function TagSelector({ allTags = [], selectedTags = {}, onChange }) {
  const categories = groupTagsByCategory(allTags);

  const handleToggle = (category, tag) => {
    const categoryTags = selectedTags[category] || [];

    const isSelected = categoryTags.includes(tag);
    const multiAssignable = categories[category].multiAssignable;

    const newCategoryTags = multiAssignable
      ? (isSelected ? categoryTags.filter(t => t !== tag) : [...categoryTags, tag])
      : (isSelected ? [] : [tag]);

    onChange({
      ...selectedTags,
      [category]: newCategoryTags
    });
  };

  return (
    <div className="tag-selector">
      {Object.entries(categories).map(([category, group]) => (
        <fieldset key={category} className="tag-category">
          <legend>{category}</legend>
          <div className="tag-options">
            {group.tags.map(tag => {
              const isSelected = selectedTags[category]?.includes(tag);
              return (
                <label key={tag} className={`tag-pill ${isSelected ? 'selected' : ''}`}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => handleToggle(category, tag)}
                  />
                  {tag}
                </label>
              );
            })}
          </div>
        </fieldset>
      ))}
    </div>
  );
}

function groupTagsByCategory(tags) {
  const grouped = {};
  for (const tag of tags) {
    if (!tag || tag.type === 'ageRule') continue;
    const name = typeof tag.name === 'string' ? tag.name.trim() : '';
    if (!name) continue;

    const cat = tag.category || 'Uncategorised';
    if (!grouped[cat]) {
      grouped[cat] = {
        multiAssignable: !!tag.multiAssignable,
        tags: []
      };
    } else {
      grouped[cat].multiAssignable = grouped[cat].multiAssignable || !!tag.multiAssignable;
    }
    if (!grouped[cat].tags.includes(name)) grouped[cat].tags.push(name);
  }
  return grouped;
}

TagSelector.propTypes = {
  allTags: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string,
    multiAssignable: PropTypes.bool
  })).isRequired,
  selectedTags: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
